module.exports = __webpack_public_path__ + "static/media/cm.5799ad4c.svg";